import { useTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { isAfter } from 'date-fns';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginContext } from '../contexts/LoginContext';
import styles from '../styles/TestSeriesCard.module.css';


export default function TestSeriesCard({ courseName, objective, onEnroll, image, description, courseId, code, courseTestStatusObj, targetAudience, subscriptionstatus, trailCourse, trailEndDate }) {

  const { t } = useTranslation();
  const theme = useTheme();
  const { UserId, setPageKey, setCourseId, assessment, setAssessmet, testSeriesObj, setTestSeriesObj, setTestSeriesCardStatus, setTopicId } = useContext(LoginContext)

  async function oncall(courseId, testSeriesCardStatus) {
    // const courseTestDetails = await UseGetCourseAssignedTests(UserId ? UserId : null, testSeriesCardStatus, courseId ?? null)
    // console.log(courseTestDetails, "courseTestDetails")
    // setTestSeriesObj(courseTestDetails);
    setPageKey(5)
    console.log("testseriescarsstatus", testSeriesCardStatus);
    setTestSeriesCardStatus(testSeriesCardStatus)
    setTopicId(courseId);
    setAssessmet(false)
  }
  let daysLeft = null;
  let trialStatusText = null;
  if (trailCourse && trailEndDate) {
    const date = new Date(trailEndDate);
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    const now = new Date();
    const isActive = isAfter(localDate, now);

    if (isActive) {
      const diffTime = localDate - now;
      // ceil so partial day counts as 1 day left
      daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      trialStatusText = `Only ${daysLeft} day${daysLeft > 1 ? 's' : ''} left`;
    } else {
      trialStatusText = 'Trial expired';
    }
  }
  return (
    <Card style={{ marginBottom: '40px' }} sx={{ maxWidth: 345 }}>
      <CardMedia
        component="img"
        alt="series Image"
        height="200"
        image={image ?? '/Gemini_image_not_available.jpg'}
      />
      <CardContent>
        <Typography className={styles.cardHeader} gutterBottom variant="h5" component="div">
          {courseName.length > 38 ? courseName.substr(0, 38) + '...' : courseName}
        </Typography>
        <span className={styles.cardDescription}>
          {objective ? objective.substr(0, 135) : <i>none</i>} {targetAudience ? `(${targetAudience.substr(0, 135)})` : ''}
        </span>

        {(trailCourse && (subscriptionstatus && subscriptionstatus === 1)) && (
          <div
            style={{
              marginTop: '8px',
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
              flexWrap: 'nowrap',
            }}
          >
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: '#012248 !important',
                color: '#fff !important',
                fontFamily: 'Poppins',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#012248 !important',
                },
              }}
              onClick={onEnroll}
              className={styles.subscribeButton}
            >
              Subscribe
            </Button>

            {trialStatusText && (
              <Typography
                variant="body2"
                sx={{
                  fontSize: '12px',
                  fontFamily: 'Poppins',
                  whiteSpace: 'nowrap',
                }}
                className={`${styles.trialBadge} ${trialStatusText === 'Trial expired' ? styles.trialExpired : ''}`}
              >
                {trialStatusText}
              </Typography>
            )}
          </div>
        )}

        {/* <Typography className={styles.cardDescription} variant="body2" color="text.secondary">
          {objective ? objective.substr(0, 135) : <i>none</i>} {targetAudience ? `(${targetAudience.substr(0, 135)})` : ''}
        </Typography> */}
      </CardContent>
      <Grid container>
        <Grid item xs={12} sm={6} md={6}>
          <Button disabled={(!courseTestStatusObj || (subscriptionstatus === 1 && trialStatusText === 'Trial expired'))} className={`${styles.cardActionButtons} ${styles.Assessments}`} onClick={() => oncall(courseId, "PENDING")}>{t('assignedTests')} ({`${courseTestStatusObj ? courseTestStatusObj.total : 0}`})</Button>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Button disabled={(!courseTestStatusObj || (subscriptionstatus === 1 && trialStatusText === 'Trial expired'))} className={`${styles.cardActionButtons} ${styles.inprogress}`} onClick={() => oncall(courseId, "INPROGRESS")}>{t('inprogress')} ({`${courseTestStatusObj ? courseTestStatusObj.inProgress : 0}`})</Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={6} md={6}>
          <Button disabled={(!courseTestStatusObj || (subscriptionstatus === 1 && trialStatusText === 'Trial expired'))} className={`${styles.cardActionButtons} ${styles.pending}`} onClick={() => oncall(courseId, "PENDING")} size="small">{t('pending')} ({`${courseTestStatusObj ? courseTestStatusObj.pending : 0}`})</Button>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Button disabled={(!courseTestStatusObj || (subscriptionstatus === 1 && trialStatusText === 'Trial expired'))} className={`${styles.cardActionButtons} ${styles.completed}`} onClick={() => oncall(courseId, "COMPLETED")} size="small">{t('completed')} ({`${courseTestStatusObj ? courseTestStatusObj.completed : 0}`}) </Button>
        </Grid>
      </Grid>
      {/* <div className={styles.actionContainer} xs={12} sm={6} md={6} lg={3}>
        <Button color='warning' disabled={!courseTestStatusObj} className={styles.cardActionsButtons} onClick={() => oncall(courseId, "ALL")} size="small">{t('assignedTests')} ({`${courseTestStatusObj ? courseTestStatusObj.total : 0}`})</Button>
        <Button style={{ color: courseTestStatusObj ? '#E8403C' : '' }} disabled={!courseTestStatusObj} className={styles.cardActionsButtons} onClick={() => oncall(courseId, "INPROGRESS")} size="small">{t('inprogress')} ({`${courseTestStatusObj ? courseTestStatusObj.inProgress : 0}`})</Button>
        <Button style={{ color: courseTestStatusObj ? '#0FB6CB' : '' }} disabled={!courseTestStatusObj} className={styles.cardActionsButtons} onClick={() => oncall(courseId, "PENDING")} size="small">{t('pending')} ({`${courseTestStatusObj ? courseTestStatusObj.pending : 0}`})</Button>
        <Button color='success' disabled={!courseTestStatusObj} className={styles.cardActionsButtons} onClick={() => oncall(courseId, "COMPLETED")} size="small">{t('completed')} ({`${courseTestStatusObj ? courseTestStatusObj.completed : 0}`}) </Button>
      </div> */}
    </Card>
  );
}